import { baseColor, primaryFont, secondaryColor } from '../../../styles/general/theme';
import { css } from 'styled-components';

export const IsuRichTextStyle = css<{
  checkMarkIconSrc?: string;
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  font-family: ${primaryFont};

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.standardPro &&
    css`
      p {
        margin: 0;
      }

      td {
        padding: 10px;
      }

      tbody tr:first-child {
        background-color: ${secondaryColor(100)};
        color: ${baseColor(900)};
        font-size: 18px;
        text-transform: uppercase;
      }

      tr {
        border: 1px solid ${baseColor(900)};
        color: ${baseColor(150)};
        font-weight: 400;
        font-family: ${primaryFont};
        background-color: ${baseColor(250)};
      }
    `};

  .richtext-tooltip {
    & svg {
      circle {
        stroke-width: 0.7;
        stroke: ${baseColor(100)};
      }

      path {
        fill: ${baseColor(100)};
        stroke-width: 0.5;
        stroke: ${baseColor(100)};
      }
    }
  }
`;
